import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PROMOS_QUERY_KEY} from "../queryKeys";

type ArchivePromoVariables = {id: number};

const archivePromo = async ({id}: ArchivePromoVariables): Promise<boolean> => {
  const response = await axiosReachInstance.delete<boolean, AxiosResponse<boolean>>(`/promos/${id}`);
  return response.data;
};

export const useArchivePromo = (
  options?: BaseMutationOptions<boolean, ArchivePromoVariables>
): BaseUseMutationResult<boolean, ArchivePromoVariables> => {
  return useBaseMutation<boolean, ArchivePromoVariables>(archivePromo, {
    ...options,
    prefixKeysToInvalidate: () => [[PROMOS_QUERY_KEY]],
  });
};
